import { useSession } from '@/shared/hooks/useSession'

type Resource =
  | 'installation'
  | 'productionRoute'
  | 'emissionReport'
  | 'precursor'
  | 'importerRequest'
  | 'precursorRequest'
  | 'materialManagement'
  | 'organization'
  | 'integration'
  | 'internal'

type Action = 'create' | 'read' | 'update' | 'delete' | 'share' | 'submit' | 'manage-users'

const CHALCO_ORG_ID: string | undefined = import.meta.env.VITE_CHALCO_ORG_ID

export const usePermissions = () => {
  const { session } = useSession()
  const organizationId = session?.organization?.id
  const permissions = [
    ...(session?.permissions || []),
    ...(organizationId === CHALCO_ORG_ID ? ['integration:*'] : []),
  ]
  const checkPermission = (resource: Resource, action: Action) => {
    const perm = `${resource}:${action}`
    return (
      permissions.includes(perm) ||
      permissions.includes(`${resource}:*`)
    )
  }

  return {
    checkPermission,
  }
}
